import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: block;
  text-align: center;
`

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
`
export const Title = styled.div`
  font-size: 24px;
  margin: 16px 0 18px 0;
  font-family: Circular-Std-Bold;
`

export const Subtitle = styled.div`
  color: ${colors.strongGray};
  margin-bottom: 20px;
`
export const Footer = styled.div`
  color: ${colors.strongGray};
`

export const RadioArea = styled.div`
  border: 1px solid;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 20px;
  gap: 8px;
  width: 100%;
  height: 15px;
  border-color: ${({ selected }) => (selected ? colors.primary : colors.softGray)};
  margin-bottom: 20px
`
export const FieldsArea = styled.div`
  width: 85%;
  margin-top: 8px;
`
